import React, { useState } from 'react'
import { Section, Image, TaglineTitleContent, Link } from 'newComponents'
import { ReactComponent as Circles } from '../../../images/home/sdk-circle.svg'
import { ReactComponent as LeftStars } from '../../../images/home/sdk-left-stars.svg'
import { ReactComponent as RightStars } from '../../../images/home/sdk-right-stars.svg'
import './styles.scss'

const HomeSdks = (props) => {
  const { tagline, title, content, columns, sdks } = props

  const sdkTagline = tagline?.html
  const sdkTitle = title?.html
  const sdkContent = content?.html

  const client = 'Client-side'
  const server = 'Server-side'

  const [stack, setStack] = useState(client)

  const handleSetStack = (event, newStack) => {
    event.preventDefault()
    setStack(newStack)
  }

  const filteredSdks = sdks.filter((sdk) => sdk.sdk_stack === stack)

  return (
    <Section className="home-sdk">
      <Circles className="home-sdk-circles" />
      <LeftStars className="home-sdk-left-stars" />
      <RightStars className="home-sdk-right-stars" />
      <div className="home-sdk-top">
        <TaglineTitleContent tagline={sdkTagline} title={sdkTitle} content={sdkContent} />
      </div>
      <div className="home-sdk-button-group">
        <Link
          to="#client"
          className={`home-sdk-button ${stack === client ? 'active' : ''}`}
          onClick={(event) => handleSetStack(event, client)}
        >
          {client}
        </Link>
        <Link
          to="#client"
          className={`home-sdk-button ${stack === server ? 'active' : ''}`}
          onClick={(event) => handleSetStack(event, server)}
        >
          {server}
        </Link>
      </div>
      <div className="home-sdk-grid">
        {filteredSdks.map((sdk) => {
          const { sdk_icon: sdkIcon, sdk_name: sdkName, sdk_link: sdkLink } = sdk
          const sdkNameIcon = sdkIcon?.url
          const sdkNameText = sdkName?.text
          const sdkLinkUrl = sdkLink?.url

          return (
            <Link to={sdkLinkUrl} className="home-sdk-item" key={sdkNameText}>
              <Image image={sdkNameIcon} alt={sdkNameText} />
            </Link>
          )
        })}
      </div>
      <div className="home-sdk-columns">
        {columns.map((column) => {
          const {
            sdk_column_title: columnTitle,
            sdk_column_content: columnContent,
            sdk_column_icon: columnIcon,
            sdk_column_link_text: columnLinkTextObj,
            sdk_column_link: columnLink
          } = column

          const columnTitleText = columnTitle?.text
          const columnTitleHtml = columnTitle?.html
          const columnContentHtml = columnContent?.html
          const columnIconUrl = columnIcon?.url
          const columnLinkText = columnLinkTextObj?.text
          const columnLinkUrl = columnLink?.url

          return (
            <Link to={columnLinkUrl} className="home-sdk-column" key={columnTitleText}>
              {columnIconUrl && <Image image={columnIconUrl} alt={columnTitleText} className="home-sdk-column-icon" />}
              <div>
                {columnTitleHtml && (
                  <div className="home-sdk-column-title" dangerouslySetInnerHTML={{ __html: columnTitleHtml }} />
                )}
                <div className="home-sdk-column-content" dangerouslySetInnerHTML={{ __html: columnContentHtml }} />
                {columnLinkUrl && (
                  <Link className="home-sdk-column-link" withChevron>
                    {columnLinkText}
                  </Link>
                )}
              </div>
            </Link>
          )
        })}
      </div>
    </Section>
  )
}

export default HomeSdks
